// extracted by mini-css-extract-plugin
export default {"container":"OffersContainer_container__GtpPM"};